module.exports = __webpack_public_path__ + "static/media/VMWM_IPO_System_Terms_and_Conditions.dd502c3c.pdf";